import store from '@/store'
import { CLEAR, INIT, SET_LOADING_STATUS, SET_STATUS_MESSAGE, SPLICE, SET_TOTAL_COUNT } from './mutation-types'

const state = {
  groups: [],
  totalCount: 0,
  status: {
    loading: false,
    message: 'Loading'
  }
}

const getters = {
  getLoadingStatus: (state) => {
    return state.status.loading
  },
  getLoadingText: (state) => {
    return state.status.message
  },
  getAllGroups: (state) => {
    return state.groups
  },
  getTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  setLoadingStatus ({ commit }, { val }) {
    commit(SET_LOADING_STATUS, { val })
  },
  setStatusMessage ({ commit }, { message }) {
    commit(SET_STATUS_MESSAGE, { message })
  },
  async init ({ commit }, { newGroups, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_TOTAL_COUNT, { val: totalCount })
      commit(INIT, { newGroups, totalCount: isFullArraySize ? totalCount : newGroups.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  // index is the current index
  async next ({ commit }, { newGroups, startIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SPLICE, { newGroups, startIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  clear ({ commit }) {
    commit(CLEAR)
  },
  setTotalCount ({ commit }, { val }) {
    commit(SET_TOTAL_COUNT, { val })
  }
}

const mutations = {
  [SET_LOADING_STATUS] (state, { val }) {
    state.status.loading = val
  },
  [SET_STATUS_MESSAGE] (state, { message }) {
    state.status.message = message
  },
  [INIT] (state, { newGroups, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newGroups))
    state.groups = new Array(totalCount)
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'groupContacts',
        params: { groupId: obj.id },
        query: { groupName: obj.name } }
      return obj
    })
    state.groups.splice(0, objs.length, ...mappedObjs)
  },
  [SPLICE] (state, { newGroups, startIndex }) {
    const objs = JSON.parse(JSON.stringify(newGroups))
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'groupContacts',
        params: { groupId: obj.id },
        query: { groupName: obj.name } }
      return obj
    })
    state.groups.splice(startIndex, objs.length, ...mappedObjs)
  },
  [SET_TOTAL_COUNT] (state, { val }) {
    state.totalCount = val
  },
  [CLEAR] (state) {
    state.groups = []
    state.status = {
      loading: false,
      message: 'Loading Groups. Please wait...'
    }
  }
}

export const group = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
